<template>
  <el-table-column
    prop="count"
    label="Mennyiség"
    width="170"
  >
    <template slot-scope="scope">
      {{ scope.row.count * scope.row.count_per_pack }} db<span v-if="scope.row.count_per_pack !== 1"> ({{ scope.row.count }} {{ scope.row.pack_type_name }})</span>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'count',
};
</script>
